
import { createApp } from 'vue'
import App from './App.vue'
import './assets/global.css'
import router from "./router/router.js";
import Toast from './components/Toast.vue'
const app = createApp(App);
app.use(router);
app.component('Toast', Toast);

app.mount("#app");
